import React from "react";
import PropTypes from "prop-types";
import { Modal, Dropdown, Checkbox, Message } from "semantic-ui-react";

const FeedbackModal = ({
  isOpen,
  onClose,
  onSubmit,
  newFeedback,
  setNewFeedback,
  selectedCategory,
  setSelectedCategory,
  isAnonymous,
  setIsAnonymous,
  isSubmitting,
  error,
  isMobile,
  categoryOptions,
  categoryConfig,
  userName,
  MIN_FEEDBACK_LENGTH = 10,
}) => {
  return (
    <Modal
      dimmer="blurring"
      open={isOpen}
      onClose={onClose}
      size={isMobile ? "fullscreen" : "small"}
      closeIcon
      style={{
        margin: isMobile ? "0" : "auto",
        maxWidth: isMobile ? "100%" : "500px",
      }}
    >
      <Modal.Header>Share Your {selectedCategory || "Feedback"}</Modal.Header>
      <Modal.Content>
        {error && <Message negative content={error} />}
        <form
          onSubmit={onSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          {!selectedCategory && (
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "0.5rem",
                  fontWeight: "bold",
                }}
              >
                Category *
              </label>
              <Dropdown
                placeholder="Select feedback category"
                fluid
                selection
                value={selectedCategory}
                onChange={(e, { value }) => setSelectedCategory(value)}
                options={categoryOptions}
                style={{ marginBottom: "0.5rem" }}
              />
            </div>
          )}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "1rem",
              borderRadius: "8px",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                marginBottom: "0.5rem",
                fontWeight: "bold",
                fontSize: "0.9rem",
              }}
            >
              Privacy Settings
            </div>
            <Checkbox
              label={
                <label style={{ fontSize: "0.9rem", marginLeft: "0.5rem" }}>
                  Post anonymously
                </label>
              }
              checked={isAnonymous}
              onChange={(e, { checked }) => setIsAnonymous(checked)}
            />
            <div
              style={{
                fontSize: "0.8rem",
                color: "#666",
                marginTop: "0.5rem",
                marginLeft: "1.5rem",
              }}
            >
              {isAnonymous
                ? 'Your feedback will be posted as "Anonymous"'
                : `Your feedback will be posted as "${userName}"`}
            </div>
          </div>
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >
              Your {selectedCategory || "Feedback"} *
            </label>
            <textarea
              placeholder="What's on your mind?"
              value={newFeedback}
              onChange={(e) => setNewFeedback(e.target.value)}
              rows={5}
              style={{
                padding: "0.75rem",
                fontSize: "1rem",
                borderRadius: "8px",
                border: "1px solid #ddd",
                width: "100%",
                resize: "vertical",
                fontFamily: "inherit",
              }}
            />
            <div
              style={{
                fontSize: "0.8rem",
                color: "#666",
                marginTop: "0.25rem",
              }}
            >
              {newFeedback.length}/{MIN_FEEDBACK_LENGTH} characters minimum
            </div>
          </div>
          <button
            type="submit"
            disabled={isSubmitting || !newFeedback.trim() || !selectedCategory}
            style={{
              padding: "0.75rem",
              backgroundColor:
                isSubmitting || !newFeedback.trim() || !selectedCategory
                  ? "#ccc"
                  : categoryConfig[selectedCategory]?.color || "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor:
                isSubmitting || !newFeedback.trim() || !selectedCategory
                  ? "not-allowed"
                  : "pointer",
              fontSize: "1rem",
              fontWeight: "bold",
            }}
          >
            {isSubmitting
              ? "Posting..."
              : `Post ${selectedCategory || "Feedback"}`}
          </button>
        </form>
      </Modal.Content>
    </Modal>
  );
};

FeedbackModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  newFeedback: PropTypes.string.isRequired,
  setNewFeedback: PropTypes.func.isRequired,
  selectedCategory: PropTypes.string.isRequired,
  setSelectedCategory: PropTypes.func.isRequired,
  isAnonymous: PropTypes.bool.isRequired,
  setIsAnonymous: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  categoryConfig: PropTypes.objectOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  userName: PropTypes.string.isRequired,
  MIN_FEEDBACK_LENGTH: PropTypes.number,
};

FeedbackModal.defaultProps = {
  error: "",
  MIN_FEEDBACK_LENGTH: 10,
};

export default FeedbackModal;
